import { showTOC } from './variables.js';

window.addEventListener('DOMContentLoaded', () => {

   console.log('TOC Script Loaded');
   console.log(showTOC);
  if(showTOC && parseInt(showTOC) === 1) {
     // get floating__side-bar-menu-item.toc__launch and make display flex
    const tocLaunch = document.querySelector('.floating__side-bar-menu-item.toc__launch');
    if (tocLaunch) {
      tocLaunch.style.display = 'flex';
    } else {
      console.error('.floating__side-bar-menu-item.toc__launch element not found.');
    }
  } else {
    console.log('TOC is disabled');
    return;
  }
    
    let allHeadings = [];
  
    console.log('TOC Script Initialized');
  
    // Select the .single__post-content container
    const content = document.querySelector('.toc__content');
  
    if (!content) {
      console.error('.toc__content element not found.');
      return;
    }
  
    // Get all headings from h1 to h6
    allHeadings = Array.from(content.querySelectorAll("h1, h2, h3, h4, h5, h6"));
  
    // Log the found headings
    console.log('Headings found:', allHeadings);
  
    if (allHeadings.length === 0) {
      console.warn('No headings found in the content.');
      return;
    }
  
    // Find the lowest heading level in the post (could be h2, h3, etc.)
    const lowestLevel = Math.min(...allHeadings.map(heading => parseInt(heading.tagName.substring(1))));
  
    // Select .da__toc container
    const toc = document.querySelector('#da__toc');
    if (!toc) {
      console.error('#da__toc element not found.');
      return;
    }
  
    // Create and append TOC structure
    const tocContainer = document.createElement("div");
    tocContainer.id = "table-of-contents";
    const tocList = document.createElement("ul");
    tocList.classList.add(`level-${lowestLevel}`); // Add class for the highest level (e.g., level-1)
    tocContainer.appendChild(tocList);
    toc.appendChild(tocContainer);
  
    // Stack to handle heading hierarchy
    let listStack = [tocList];
    let currentLevel = lowestLevel;
    let tocLinks = []; // Store all the TOC links
  
    allHeadings.forEach((heading) => {
      const level = parseInt(heading.tagName.substring(1)); // Get heading level (1-6)
    //   const id = heading.textContent.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    //   heading.id = id;

    const slugify = (text) => text.toLowerCase().trim()
        .replace(/[\s]+/g, '-')
        .replace(/[^\w-]+/g, '');

    const id = slugify(heading.textContent);
    heading.id = id;

  
      // Create list item and link
      const listItem = document.createElement("li");
      const link = document.createElement("a");
      link.href = "#" + id;
      link.textContent = heading.textContent;
      listItem.appendChild(link);
      tocLinks.push(link); // Add to tocLinks array for later use
  
      // Adjust listStack based on heading level relative to lowestLevel
      if (level > currentLevel) {
        // Create a new nested list for lower levels
        const newList = document.createElement("ul");
        newList.classList.add(`level-${level}`);
        listStack[listStack.length - 1].lastElementChild.appendChild(newList);
        listStack.push(newList);
      } else if (level < currentLevel) {
        // Pop out of the current list if moving back to a higher-level heading
        while (listStack.length > (level - lowestLevel + 1)) {
          listStack.pop();
        }
      }
  
      // Append the list item to the current list
      listStack[listStack.length - 1].appendChild(listItem);
      currentLevel = level;
    });
  
    // Add 'active' class to the first TOC item
    if (tocLinks.length > 0) {
      tocLinks[0].classList.add('active');
    }
  
    // Smooth scroll to heading with offset
    tocLinks.forEach(link => {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        tocLinks.forEach(t => t.classList.remove('active')); // Remove active class from all TOC links
        this.classList.add('active'); // Add active class to the clicked link
  
        const targetId = this.getAttribute('href').substring(1); // Get target ID
        const targetElement = document.getElementById(targetId);

        console.log('Target element:', targetElement);
  
        if (targetElement) {
          // Smooth scroll to the heading with 100px offset
          let headerHeight = document.querySelector('header').offsetHeight;
          let adminBarHeight = 0;
          // Get admin bar
          const adminBar = document.querySelector('#wpadminbar');
          if (adminBar) {
            // Get admin bar height
            adminBarHeight = adminBar.offsetHeight;
          }
          window.scrollTo({
            top: targetElement.getBoundingClientRect().top + window.scrollY - (headerHeight + adminBarHeight), // 48px padding added for sticky TOC
            behavior: 'smooth'
          });
        }
      });
    });
  
  // Helper function to check which heading is currently in view
  function getClosestHeading() {
    let closestHeading = null;
    const threshold = 25; // Adjust this threshold to suit the design
  
    for (let i = 0; i < allHeadings.length; i++) {
      const rect = allHeadings[i].getBoundingClientRect();
      
      // Check if the heading is within the threshold from the top
      if (rect.top >= threshold && rect.top < threshold + window.innerHeight / 2) {
        closestHeading = allHeadings[i];
        break; // Stop at the first heading within the view
      }
    }
  
    return closestHeading;
  }
  
  
  
  
  // Debounce the scroll event listener
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
  
    scrollTimeout = setTimeout(() => {
      const closestHeading = getClosestHeading();
  
      // Update active class in the TOC
      if (closestHeading) {
        tocLinks.forEach(t => t.classList.remove('active')); // Remove active class from all TOC links
        let currentLink = tocLinks.find(link => link.getAttribute('href') === '#' + closestHeading.id);
        if (currentLink) {
          currentLink.classList.add('active');
        }
      }
    }, 50); // Debounce delay (50ms to 100ms is usually smooth)
  });
  
    // Function to dynamically set the padding-top for sticky TOC
  function addPaddingToToc() {
    let adminBarHeight = 0;
  
    // Get height of the header
    const header = document.querySelector('.header__wrapper');
    const headerHeight = header ? header.offsetHeight : 0;
  
    // Get admin bar
    const adminBar = document.querySelector('#wpadminbar');
    if (adminBar) {
      // Get admin bar height
      adminBarHeight = adminBar.offsetHeight;
    }
  
    // Calculate the top position where the TOC should become sticky
    const activationPosition = headerHeight + adminBarHeight;
  
    // Get the TOC wrapper
    const tocWrapper = document.querySelector('.da__toc-wrapper');
  
    // add top style to the toc wrapper
    tocWrapper.style.top = `${headerHeight + adminBarHeight}px`;
  
    if (!tocWrapper) {
      console.error('.da__toc-wrapper element not found.');
      return;
    }
  
    // Check the current scroll position
    if (window.scrollY >= activationPosition) {
      // If scrolled past the activation position, add the 'active' class to apply the padding
      tocWrapper.classList.add('active');
    } else {
      // Otherwise, remove the 'active' class
      tocWrapper.classList.remove('active');
    }
  }
  
  // Call the function initially and on resize to adjust the sticky TOC padding
  addPaddingToToc();
  window.addEventListener('resize', addPaddingToToc);
  window.addEventListener('scroll', addPaddingToToc);
  
  });
  